var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('rect',{attrs:{"width":"2","height":"24","rx":"1","transform":"rotate(135 6.063 13.625)"}}),_vm._v(" "),_c('rect',{attrs:{"width":"2","height":"24","rx":"1","transform":"rotate(45 6.871 23.417)"}})])}
var staticRenderFns = []

export { render, staticRenderFns }